// @flow
import xws from 'api/xws/';
import type { Thunk } from 'types/redux';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Selectors
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import { getPersonId as getPersonIdFromLogin } from 'store/reducers/login/selectors';
import { getPersonId } from 'store/reducers/user/personInfo/selectors';

// Constants
import { getService } from 'constants/ajax';

export const verifyIdentity = (
  phoneNumber: string,
  email: string
): Thunk<Promise<any>> => async (dispatch, getState) => {
  const verifyService = getService('verify');
  verifyService.setCallBacks(dispatch(ajaxCallbacks()));
  const personId = getPersonIdFromLogin(getState()) || getPersonId(getState());
  const { data } = await xws(verifyService).get(verifyService.getPath(), {
    params: {
      phoneNumber,
      email,
      personId,
      tokenId: getTokenId(getState()),
      webkey: getWebkey(getState())
    }
  });
  if (data.success) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/verifyIdentity/actions.js